import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReleaseNotesComponent } from './release-notes/release-notes.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../core/libs/shared/shared.module';

@NgModule({
    declarations: [ReleaseNotesComponent],
    imports: [CommonModule, RouterModule, SharedModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GeneralModule {}
